import { Toast, ToastType } from '../components/Toast';

export interface Error {
  response?: { data?: string };
}

export const ToastHelper = (
  toastType: ToastType,
  defaultMsg: string,
  error?: Error
) => {
  let data;
  if (toastType === ToastType.DANGER) {
    if (error && error.response && error.response.data) {
      data = error.response.data;
    } else {
      data = defaultMsg;
    }
  } else {
    data = defaultMsg;
  }

  Toast.showToast({
    message: data,
    colorType: toastType
  });
};

export default ToastHelper;
